<template>
    <div class="language-selector">
        <Select class="language-selector__input"
            v-model="current"
            :options="languages"
            optionLabel="label"
            optionValue="value"
        />
    </div>
</template>

<script>
import Select from 'primevue/select';
export default {
    components: {Select},

    computed: {
        languages() {
            let options = [];

            _.forEach(this.$configuration.get('vueJs.localization.allowed'), (value, key) => {
                options.push({
                    label: value,
                    value: key
                });
            })

            return options;
        },

        current: {
            set(value) {
                this.$configuration.setLocale(value);
            },
            get() {
                return this.$configuration.getLocale();
            }
        }
    }
}
</script>

<style lang=scss>
.language-selector {
    &__input {

    }
}
</style>
